import { subDays, subMonths } from 'date-fns';
import React, { useEffect, useState } from 'react'
import { Line } from 'react-chartjs-2'
import { DASHBOARD_INTERVAL_TIMER, MULTI_TIME_ZONE } from '../../../../config';
import { GetDashbordAlertStatus } from '../../../../services/dashboardService';
import { multiTimeZoneHelper, ConvertDate } from '../../../../utils/utils';



const TODAY = "TD";
const YESTERDAY = "YD";
const SEVENDAY = "7D";
const ONEMONTH = "1M";

// Helper to get start and end date of ISO week number
function getWeekDateRange(weekNum, year) {
  // ISO week: week starts on Monday
  const simple = new Date(year, 0, 1 + (weekNum - 1) * 7);
  const dow = simple.getDay();
  let weekStart = simple;
  if (dow <= 4)
    weekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else
    weekStart.setDate(simple.getDate() + 8 - simple.getDay());
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  return {
    start: weekStart,
    end: weekEnd
  };
}

function formatDateShort(date) {
  return date
    ? date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })
    : '';
}

const AlertByTimeTrendChart = (props) => {

  let { isDarkTheme, SiteName, handleModalShow, getFromToTime, siteId, getcsvFileName } = props;
  const [chartData, setChartData] = useState([]);
  const [filteredChartData, setFilteredChartData] = useState({ labels: [], data: [] });
  const [timeframe, setTimeframe] = useState("Hourly");  // Default selection
  
  const fetchDashboardAlertStatus = () =>{
    let user = JSON.parse(localStorage.getItem('user'))
    let start = getFirstDate();
    let end = getSecondDate();
    let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
    let endCurrDate = ConvertDate(end);
    if (!user) return;
    const fromDateTime = "";
    const toDateTime = "";
    const widgetId = 5;
    const alertStatus = "";
    const alertSeverity = "";
    const alertAssociated = "";
    const interfacetypename = "";
    const clientID = "";
    const siteID = "";
    const hourly = "";
    const dayName = "";
    const weekNumber = "";
    const monthName = "";
    const clientName = "";

    // Call your API or function with all the parameters
    getDashboardAlertStatus(
        user.Id, 
        widgetId,
        fromDateTime,
        toDateTime,  
        alertStatus,
        alertSeverity,
        alertAssociated,
        interfacetypename,
        clientID,
        siteID,
        hourly,
        dayName,
        weekNumber,
        monthName,
        clientName,
        SiteName
      );
  }
  
  const getFirstDate = () => {
      let d;
      let loggedInUser = JSON.parse(localStorage.getItem('user'))
      if (MULTI_TIME_ZONE) {
        d = multiTimeZoneHelper(loggedInUser.OffsetMinutes)
      } else {
        d = new Date();
      }
      return d;
  }

  const getSecondDate = () => {
      let e;
      let loggedInUser = JSON.parse(localStorage.getItem('user'))
      if (MULTI_TIME_ZONE) {
        e = multiTimeZoneHelper(loggedInUser.OffsetMinutes)
      } else {
        e = new Date();
      }
      return e;
  }
 
  useEffect(() => {
    if (SiteName) {
      fetchDashboardAlertStatus();
    }
  }, [SiteName]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDashboardAlertStatus();
    }, DASHBOARD_INTERVAL_TIMER); // 10 seconds interval

    return () => clearInterval(interval); // Cleanup on unmount
  }, [])

  useEffect(() => {
        if (chartData.length > 0) {
          const { labels, chartData: data } = processChartData(chartData, timeframe);
          setFilteredChartData({ labels, data });
        } else {
          setFilteredChartData({ labels: [], data: [] });
        }
      }, [timeframe, chartData]);

  const processChartData = (data, timeframe) => {
      // Only include items where AlertMonitoring is true
      const filteredData = data.filter(item => item.AlertMonitoring);

      let labels = [];
      let chartData = [];

      if (timeframe === "Hourly") {
        const hourlyData = filteredData.filter((item) => item.TimeType === "Hourly");
        if (hourlyData.length === 0) {
          return { labels: [], chartData: [] };
        }
        labels = Array.from({ length: 24 }, (_, i) => i.toString());
        chartData = labels.map((hour) => {
          const found = hourlyData.find((item) => item.TimePeriod == hour);
          return found ? found.AlertCount : 0;
        });

      } else if (timeframe === "Daily") {
        const dailyData = filteredData.filter((item) => item.TimeType === "Daily");
        if (dailyData.length === 0) {
          return { labels: [], chartData: [] };
        }
        labels = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        chartData = labels.map((day) => {
          const found = dailyData.find((item) => item.TimePeriod === day);
          return found ? found.AlertCount : 0;
        });

      } else if (timeframe === "Weekly") {
        const weeklyData = filteredData.filter((item) => item.TimeType === "Weekly");
        if (weeklyData.length === 0) {
          return { labels: [], chartData: [] };
        }
        const weekNumbers = weeklyData
          .map(item => {
            const match = item.TimePeriod.match(/Week\s*(\d+)/i);
            return match ? parseInt(match[1], 10) : null;
          })
          .filter(weekNum => weekNum !== null)
          .sort((a, b) => a - b);

        const last4WeekNumbers = weekNumbers.slice(-4);
        const year = new Date().getFullYear();

        labels = last4WeekNumbers.map(weekNum => {
          const { start, end } = getWeekDateRange(weekNum, year);
          return `${formatDateShort(start)} - ${formatDateShort(end)}`;
        });

        chartData = last4WeekNumbers.map(weekNum => {
          const found = weeklyData.find(item => {
            const match = item.TimePeriod.match(/Week\s*(\d+)/i);
            return match && parseInt(match[1], 10) === weekNum;
          });
          return found ? found.AlertCount : 0;
        });

      } else if (timeframe === "Monthly") {
        const monthlyData = filteredData.filter((item) => item.TimeType === "Monthly");
        if (monthlyData.length === 0) {
          return { labels: [], chartData: [] };
        }
        const months = [...new Set(monthlyData.map(item => item.TimePeriod))].slice(-3);
        labels = months;
        chartData = labels.map((month) => {
          const found = monthlyData.find((item) => item.TimePeriod === month);
          return found ? found.AlertCount : 0;
        });
      }
      return { labels, chartData };      
    };

  
  const getDashboardAlertStatus = (
    userID,
    widgetId,
    fromDateTime,
    toDateTime,  
    alertStatus,
    alertSeverity,
    alertAssociated,
    interfacetypename,
    clientID,
    siteID,
    hourly,
    dayName,
    weekNumber,
    monthName,
    clientName,
    siteName
    ) =>{
    GetDashbordAlertStatus(
      userID,
      widgetId,
      fromDateTime,
      toDateTime,  
      alertStatus,
      alertSeverity,
      alertAssociated,
      interfacetypename,
      clientID,
      siteID,
      hourly,
      dayName,
      weekNumber,
      monthName,
      clientName,
      siteName
      )
      .then((resp) => {
        if (resp.Status === "success") {
          if(resp.Data && resp.Data.length > 0){
            setChartData(resp.Data);
          }
          else {
            setChartData([]);
          }
        } else {
          setChartData([]);
        }
      })
      .catch(err => console.log(err))
  }

const data = {
  labels: filteredChartData.labels,
  datasets: [{
    label: 'Alert',
    data: filteredChartData.data ,
    fill: false,
    borderColor: 'rgb(75, 192, 192)',
    tension: 0.1,
    fill: false,
    pointRadius: 5, 
    pointHoverRadius: 8,   
    pointBackgroundColor: 'rgba(75, 192, 192, 1)', 
    pointBorderWidth: 2  
  }]
};

const config = {
  type: 'line',
  data: data,
};

// X axis ticks config: tilt and center only for weekly
const xTicksConfig = (timeframe === "Weekly")
  ? {
      minRotation: 15,
      maxRotation: 20,
      align: 'center',
      anchor: 'center',
      autoSkip: false,
      font: {
        size: 12,
      },
    }
  : {
      autoSkip: true,
    };

const option = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      type: 'category',
      labels: filteredChartData.labels,
      offset: true,
      ticks: {
        ...(timeframe === "Weekly"
          ? {
              minRotation: 15,
              maxRotation: 20,
              align: 'center',
              anchor: 'center',
              autoSkip: false,
              font: { size: 12 },
            }
          : {
              autoSkip: true,
            }),
        color: isDarkTheme ? '#bababa' : "#bababa", // <-- set tick color for dark theme
      },
      border: {
        display: true,
        color: isDarkTheme ? '#bababa' : "#bababa",
      },
      grid:{
          display:false,
      },
    },
    y: {
      beginAtZero: false,
      ticks: {
        color: isDarkTheme ? '#bababa' : "#bababa", // <-- set tick color for dark theme
      },
      border: {
        display: true,
        color: isDarkTheme ? '#bababa' : "#bababa",
      },
      grid:{
          display:false,
      },
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          let dataset = tooltipItem.dataset;
          let value = dataset.data[tooltipItem.dataIndex];
          let label = dataset.labels ? dataset.labels[tooltipItem.dataIndex] : "";
          return `${label}: ${value}`;
        },
      },
    },
    legend: {
        display: true,
        position:'bottom',
        labels: {
          boxWidth: 14, 
          fontColor: '#474747',
          fontFamily: '7px Montserrat',
        },
    },
    animations: {
      tension: {
        duration: 1000,
        easing: 'active',
        from: 1,
        to: 0,
      }
    },
  },
  onClick: (event, elements, chart) => {
      if (elements && elements.length > 0 && typeof props.handleModalShow === "function") {
        const element = elements[0];
        const index = element.index;
        const label = chart.data.labels[index];
        props.handleModalShow({}, "Alert", getFromToTime(timeframe, label), {SiteID:[siteId]}, getcsvFileName('Alert', label), "Alert Counts By Time");
      }
  },
}


return (
  <div style={{padding:"10px", height:"90%"}}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div style={{display : "grid", gridAutoFlow: "column", gridGap:"10px"}} className='AlertTimeBtnDiv'>
              {["Hourly", "Daily", "Weekly", "Monthly"].map((type) => (
                <button
                    key={type}
                    onClick={() => setTimeframe(type)}
                    className={`${timeframe == type ? "btn btn-outline-primary active" : "btn btn-outline-primary"}`}
                >
                    {type}
                </button>
              ))}
              
              </div>
        </div>
        <div style={{padding:"10px", height:"96%", display:"flex", justifyContent:"center",alignItems:"center"}}>
            {filteredChartData.labels.length > 0 ? (
                  <Line config={config} data={data} options={option} />
              ) : (
                <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", color: "gray" }}>
                    No alerts found
                </div>
            )}
        </div>
  </div>
)
}

export default AlertByTimeTrendChart